import agent from './agent';
import feedback from './feedback';
import filterItems from './filter-items';
import insight from './insight';
import insightExplorer from './insight-explorer';
import search from './search';
import { studioQueryKeys } from './studio';
import taxonomyQueryKeys from './taxonomy';

const queryKeys = {
  feedback,
  search,
  insight,
  agent,
  filterItems,
  taxonomy: taxonomyQueryKeys,
  insightExplorer,
  studio: studioQueryKeys,
};

export default queryKeys;
